import { Component } from 'react';
import Signature from '../../Signature/Signature';
import { getCurrentFunctionName } from '../../../performanceModeManager';

class InterventionSignatureField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editionMode: false,
        }
    }

    onValidateSignature(value) {
        let fieldValue = this.props.value;
        fieldValue.value_image = value;
        this.props.fieldValueChange(fieldValue);
        this.close();
    }

    editSignature() {
        this.setState({
            editionMode: true,
        })
    }

    close() {
        this.setState({
            editionMode: false
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <div className={"control-margin-top div-signature-width " + (this.props.inputProperties.disabled ? "disabled" : "")} >
                <Signature close={this.close.bind(this)} open={this.editSignature.bind(this)}
                    currentSignature={this.props.value.value_image} onValidateSignature={this.onValidateSignature.bind(this)}
                    {...this.props.inputProperties} label={this.props.model.name}
                    onRef={ref => (this.signature = ref)} editionMode={this.state.editionMode} />
            </div>
        )
    }
}

export default InterventionSignatureField;
